/**
 * Rôle de l'admin connecté, lu dans le jeton de session à chaque appel.
 *
 * Jamais stocké à part (l'ancien localStorage.adminRole était modifiable à la
 * main et survivait à la déconnexion), jamais déduit par défaut : un jeton
 * illisible ne vaut aucun rôle, et la session est fermée. Le serveur reste
 * l'autorité ; ce module ne sert qu'à afficher ou masquer.
 */

export interface JetonLu {
  role: string | null;
  exp: number | null;
  sub: string | null;
}

/** Payload du JWT (base64url), ou null si le jeton est illisible. */
export function lireJeton(token: string | null): JetonLu | null {
  if (!token) return null;
  const parties = token.split(".");
  if (parties.length !== 3) return null;
  try {
    const b64 = parties[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(b64.padEnd(Math.ceil(b64.length / 4) * 4, "=")));
    if (typeof payload !== "object" || payload === null) return null;
    return {
      role: typeof payload.role === "string" ? payload.role : null,
      exp: typeof payload.exp === "number" ? payload.exp : null,
      sub: typeof payload.sub === "string" ? payload.sub : null,
    };
  } catch {
    return null;
  }
}

export function roleCourant(): string | null {
  return lireJeton(sessionStorage.getItem("jwtToken"))?.role ?? null;
}

/** Email de l'admin connecté, lu dans le jeton (affichage seulement). */
export function sujetCourant(): string | null {
  return lireJeton(sessionStorage.getItem("jwtToken"))?.sub ?? null;
}

export function estSuperAdmin(): boolean {
  return roleCourant() === "SUPER_ADMIN";
}

/** Purge complète de la session, y compris l'ancienne clé adminRole. */
export function fermerSession(): void {
  sessionStorage.removeItem("jwtToken");
  sessionStorage.removeItem("isLoggedIn");
  localStorage.removeItem("adminRole");
}
